var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import { StyleSheet, css } from 'aphrodite';
import { FocusedDropDownSearch } from './FocusedDropDownSearch';
import { DropDown } from './DropDown';
export var BasicDropDown = function (props) {
    var error = props.error, onChange = props.onChange, menuItems = props.menuItems, initialValue = props.initialValue, disableSearch = props.disableSearch, placeholder = props.placeholder;
    return (React.createElement(DropDown, __assign({}, { menuItems: menuItems, initialValue: initialValue }), function (_a) {
        var opened = _a.opened, selectItem = _a.selectItem, selectedItem = _a.selectedItem, setOpened = _a.setOpened, updateSearchTerm = _a.updateSearchTerm, filteredMenuItems = _a.filteredMenuItems;
        return (React.createElement("div", { tabIndex: 0, onClick: setOpened, className: css(styles.container, opened ? styles.containerBorderOpened : styles.containerBorder) },
            React.createElement("span", { className: css(styles.arrowWrapper) },
                React.createElement(FontAwesomeIcon, { icon: opened ? faCaretLeft : faCaretDown })),
            opened && !disableSearch ? (React.createElement(FocusedDropDownSearch, { onChange: updateSearchTerm, placeholder: "Search..." })) : (React.createElement("span", { className: css(styles.selectedItem, (error ? styles.selectedItemError : selectedItem ? styles.selectedItemValue : styles.selectedItemNone)) }, selectedItem ? selectedItem.label : placeholder)),
            opened && (React.createElement("ul", { className: css(styles.dropDownList) }, filteredMenuItems.map(function (item) { return (React.createElement("li", { key: item.label + "-" + item.value, onClick: selectItem(onChange, item), value: item.value, className: css(styles.dropDownItem) }, item.label)); })))));
    }));
};
var styles = StyleSheet.create({
    container: {
        'position': 'relative',
        'width': '100%',
        'outline': 'none',
        'cursor': 'pointer',
        'max-width': '544px',
        'text-align': 'left',
        'border-radius': '3px',
        'color': '#A3A3A3',
        'transition': 'border 0.5s',
        'background-color': '#FFF',
        ':hover': {
            border: '1px solid #1a66ff',
        },
    },
    containerBorder: {
        border: '1px solid #D6D6D6',
    },
    containerBorderOpened: {
        border: '1px solid #1a66ff',
    },
    arrowWrapper: {
        right: '0px',
        padding: '15px',
        position: 'absolute',
        color: '#2D2D2D',
    },
    selectedItem: {
        'user-select': 'none',
        'display': 'inline-block',
        'padding': '15px',
    },
    selectedItemError: {
        color: 'red',
    },
    selectedItemValue: {
        color: '#5E5E5E',
    },
    selectedItemNone: {
        color: '#D6D6D6',
    },
    dropDownList: {
        'margin': '0 -1px',
        'padding': '0',
        'z-index': '300',
        'width': '100%',
        'max-height': '400px',
        'overflow-y': 'scroll',
        'position': 'absolute',
        'list-style-type': 'none',
        'background-color': '#FFF',
        'border': '1px solid #1a66ff',
        'border-top': '0',
    },
    dropDownItem: {
        'padding': '15px',
        ':hover': {
            'color': '#5E5E5E',
            'background-color': '#F5F8FA',
        },
    },
    dropDownItemSelected: {
        'selected': 'selected',
        'color': '#5E5E5E',
        'background-color': '#F5F8FA',
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/CommonUI/Controls/BasicDropDown.js
// module id = 1269
// module chunks = 0